<template>
  <!-- 注册获得果实微授权免费体验账号 -->
  <div class="getExperienceAccount">
      <ul>
          <li class="lino1">
              <p>注册获得果实微授权免费体验账号</p>
              <p>
                  <span>免费5篇授权文章</span>
                  <span>免费5天试用体验</span>
              </p>
          </li>
          <li class="lino2">
              <div class="inputBox">
                    <input type="text" placeholder="请输入手机号" class="inputbox_inputCenter">
                    <span class="inputbox_bittonRight">立即领取</span>
                </div>
          </li>
          <li class="lino3">
              咨询电话 010-56276931
          </li>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="less">
.getExperienceAccount{
    height:105px;
    background:rgba(51,51,51,0.8);
    ul{
        width: 1200px;
        margin:auto;
        color:#ffffff;
        display: flex;
        align-items: center;
        height: 100%;
        .lino1{
            p:nth-child(1){
                font-size: 24px;
            }
            p:nth-child(2){
                padding-top: 10px;
                font-size: 16px;
                display: flex;
                justify-content: space-between;
            }
        }
        .lino2{
            padding: 0 160px 0 84px;
            .inputBox{
                overflow: hidden;
                width: 316px;
                height: 40px;
                display: flex;
                margin-right:16px;
                align-items: center;
                border-radius:6px;
                justify-content: space-between;
                .inputbox_inputCenter{
                    display: block;
                    width: 173px;
                    height: 100%;
                    outline:none;
                    text-indent: 0.5em;
                    border:none;
                }
                .inputbox_bittonRight{
                    width: 143px;
                    height: 100%;
                    border: none;
                    color: #ffffff;
                    font-size: 14px;
                    display: block;
                    background: rgba(64, 125, 248, 1);
                    transition: 0.3s;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    font-weight:600;
                }
                .inputbox_bittonRight:hover{
                    background:rgba(64, 125, 248, 0.95)
                }
                .inputbox_bittonRight:active{
                    background:rgba(64, 125, 248, 1)
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/home/homeComponents/getExperienceAccount.vue